var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatmapChartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.889,
    height: 28.78,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37306"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37301"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37300"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17425",
    fill: "#185edf",
    d: "M4.402 9.008h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17431",
    fill: "rgba(24,94,223,0.4)",
    d: "M4.402.527h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17426",
    fill: "#185edf",
    d: "M12.571 9.008h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17432",
    fill: "#185edf",
    d: "M12.571.527h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17428",
    fill: "#185edf",
    d: "M20.74 17.49h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17429",
    fill: "#185edf",
    d: "M12.571 17.49h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17430",
    fill: "rgba(24,94,223,0.2)",
    d: "M4.402 17.49h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17433",
    fill: "rgba(24,94,223,0.2)",
    d: "M20.74.527h7.71v7.71h-7.71z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17434",
    fill: "rgba(24,94,223,0.2)",
    d: "M20.74 9.008h7.71v7.71h-7.71z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21669",
    d: "M29.889 28.78H2.135A2.1 2.1 0 0 1 0 26.724V0h2.135v26.724h27.754Z",
    fill: "#185edf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapChartBlue);
export default __webpack_public_path__ + "static/media/heatmap-chart-blue.faccdc789d9fccd9b21948cd9067806a.svg";
export { ForwardRef as ReactComponent };